import { Outlet } from 'react-router-dom';
import Header from './modules/header/Header';
import Navigation from './modules/navigation/Navigation';
import GlobalNotificationManager from './modules/notification/GlobalNotificationManager';
import Toaster from './uikit/toaster';
import './utils/axiosConfig';

export default function Layout() {
  return (
    <>
      <div className="flex h-screen layout site-wrapper bg-[#F3F4F5] overflow-hidden">
        <Navigation />
        <main className="flex-1 flex flex-col min-w-0">
          <Header />
          <GlobalNotificationManager />
          <div className="flex-1 md:p-4 bg-[#F3F4F5] overflow-auto">
            <Outlet />
          </div>
        </main>
      </div>
      <Toaster />
    </>
  );
}
